import React from 'react';
import { bigIdea } from '../data/tables';
export function BigIdea() {
  return <section aria-labelledby="big-idea-heading" className="bg-ink" data-id="element-29" data-mp="2p9ohlnduaoz7">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-30" data-mp="2pc1a2uh84hqi">
        <div className="max-w-[46rem]" data-id="element-31" data-mp="2uacg0u4ee83g">
          <h2 id="big-idea-heading" className="font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-paper md:text-[46px]" data-id="element-32" data-mp="2z849vtols4aa">
            {bigIdea.heading}
          </h2>

          <p className="mt-9 font-serif text-[24px] italic leading-[1.35] text-brass md:text-[32px]" data-id="element-33" data-mp="26ioz950uodew">
            {bigIdea.payoff}
          </p>

          <p className="mt-9 text-[17px] leading-[1.65] text-paper/80 md:text-[18px]" data-id="element-34" data-mp="2bh8n5az07z9w">
            {bigIdea.body}
          </p>
        </div>
      </div>
    </section>;
}